<template>
  <div>
    <b-row class="my-5 mx-0" align-h="center">
      <b-col cols="11">
        <Header />

        <!-- Alert -->
        <b-row class="mb-2">
          <b-col>
            <b-alert show variant="info" class="mt-2 mb-0 mx-2" dismissible>
              <font-awesome-icon :icon="['far', 'info-circle']" fixed-width />
              <span class="font-weight-bold fs-17">Nota:</span>
              <span class="fs-17 text-alert">
                Si un usuario no pertenece a ningún grupo de autorización activo, por defecto el aprobador es la Jefatura configurada en la aplicación.
              </span>
            </b-alert>
          </b-col>
        </b-row>

        <FiltersCard
          :form="filterForm"
          @select-action="setSelectedAction"
          @select-module="setSelectedModule"
          @reset-filters="resetFilters"
          @display-alert="displayAlert"
        />

        <GroupMembersTable
          v-show="filterForm.selectedActionId != null && filterForm.selectedActionId != null && filterForm.selectedGroupId != null"
          :selected-group-id="filterForm.selectedGroupId === null ? 'reset' : filterForm.selectedGroupId"
          :filterForm="filterForm"
          @display-alert="displayAlert"
        />
      </b-col>
    </b-row>

    <!-- Alert -->
    <ToastAlert :show="alertShow" :variant="alertVariant" @close="alertShow = false">
      {{ alertMessage }}
    </ToastAlert>

  </div>
</template>

<script>
import Header from './Header'
import FiltersCard from './FiltersCard'

import Button from '../../../components/shared/Button'
import Modal from '../../../components/shared/Modal'
import UserSearchInput from '../../../components/shared/UserSearchInput'
import NameInitialsIcon from '../../../components/shared/NameInitialsIcon'
import ToastAlert from '../../../components/shared/ToastAlert'
import GroupMembersTable from './GroupMembersTable.vue'

export default {
  name: 'Index',
  components: { Button, Header, FiltersCard, GroupMembersTable, Modal, UserSearchInput, NameInitialsIcon, ToastAlert },
  data () {
    return {
      // filters start
      filterForm: {
        selectedModuleId: null,
        selectedActionId: null,
        selectedGroupId: null
      },
      selectedAction: {},
      selectedModule: {},
      // alerts start
      alertShow: false,
      alertVariant: null,
      alertMessage: ''
    }
  },
  methods: {
    // members
    searchApprovalMembers(state) {
      console.log('searchApprovalMembers', state)
    },
    // Filters card
    setSelectedModule (selectedModule) {
      this.selectedModule = selectedModule
    },
    setSelectedAction (selectedAction) {
      this.selectedAction = selectedAction
    },
    resetFilters () {
      this.selectedAction = {}
      this.selectedModule = {}
    },
    // Alerts
    displayAlert ({ message, variant }) {
      this.alertVariant = variant
      this.alertMessage = message
      this.alertShow = true
      setTimeout(() => this.alertShow = false, 2000)
    }
  }
}
</script>

<style scoped>
@media (max-width: 991.98px) {
  .text-alert {
    font-size: 0.9375rem;
  }
}
</style>
